import { createFileRoute } from '@tanstack/react-router'
import { Recibos } from '@/features/config/Recibos'

/** Emissor dos recibos, fora do Consultório porque é dado fiscal e muda pouco. */
export const Route = createFileRoute('/_app/app/config/recibos')({ component: Recibos })
